import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const FieldOfficerOfPartnerTable = ({ fieldOfficers }) => {
  const navigate = useNavigate();
  const getRecords = () => {
    return fieldOfficers.map((fieldOfficer, i) => (
      <tr key={fieldOfficer.field_officer_id}>
        <td data-label='S.No.' className='text-capitalize'>
          {i+1}
        </td>
        <td data-label='NAME' className='text-capitalize'>
          {fieldOfficer.name}
        </td>
        <td data-label='MOBILE'>{fieldOfficer.mobile_no}</td>
        <td data-label='ADDRESS'>{fieldOfficer.address}</td>
        <td data-label='STATE'>{fieldOfficer.state}</td>
        <td data-label='REPORTS'>
          <Link
            to={`/field-officer/reports/${fieldOfficer.field_officer_id}`}
          >
            {fieldOfficer.report_count}
          </Link>
        </td>
        <td data-label='VIEW'>
          <Button
            variant='dark'
            onClick={() =>
              navigate(`/field-officers/${fieldOfficer.field_officer_id}`)
            }
          >
            Continue
          </Button>
        </td>
      </tr>
    ));
  };
  return (
    <table
      className={`table table-striped text-center table-borderless ${
        fieldOfficers.length > 1 ? 'align-middle' : ''
      }`}
    >
      <thead className='table-dark align-top'>
        <tr>
          <th>S.No.</th>
          <th>NAME</th>
          <th>MOBILE</th>
          <th>ADDRESS</th>
          <th>STATE</th>
          <th>Reports</th>
          <th>VIEW</th>
        </tr>
      </thead>
      <tbody>
        {fieldOfficers.length > 0 ? (
          getRecords()
        ) : (
          <tr>
            <td className='no-entries' colSpan='10'>
              No Entries Found...
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default FieldOfficerOfPartnerTable;
